import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_AdminDashboard_ParticipantActivitiesDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetDashboardActivities = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_AwardService_Dtos_AdminDashboard_ParticipantActivitiesDto> | undefined,
  unknown
> => {
  const dashboardActivities = useQuery(['getDashboardActivities'], async () => {
    // Add 5 second delay
    await new Promise((resolve) => setTimeout(resolve, 5000));
    return await handleRequest(DashboardService.getApiAwardApiAppDashboardActivities());
  });

  return dashboardActivities;
};

export default useGetDashboardActivities;
